export default "__VITE_ASSET__CNmjo73f__"